export class GcsFile {
  id?: number;
  fileName?: string | null;
  fileType?: string | null;
  file?: File;
  uploadSignedUrl?: string;
}
